<template>
    <div>
        <!-- <div>
            <Breadcrumbs :extraBreadcrumb="extraBreadcrumbItems" :class="breadcrumbClass" />

        </div> -->
        <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="6000">
            <span v-if="snackbar_msg != null">{{ snackbar_msg }}</span>
            <v-btn dark text @click="snackbar = false">Close</v-btn>
        </v-snackbar>
        <v-card class="box">
            <v-toolbar flat dense class="toolbar">
                <v-toolbar-title>Payment Transaction History Report</v-toolbar-title>
                <v-divider class="mx-4" inset vertical></v-divider>
                <v-spacer></v-spacer>
            </v-toolbar>
            <v-row justify="center" dense>
                <v-col cols="12" sm="12" md="12" lg="12">
                    <v-icon color="error">*</v-icon>
                    From Date ::
                    <input class="mt-7 pt-0" id="datePickerId" type="date" v-model="fromdate" />
                    <v-icon color="error" class="ml-3">*</v-icon>
                    To Date ::
                    <input class="mt-7 ml-2 pt-0" id="datePickerId" type="date" v-model="todate" />
                </v-col>
                <v-col cols="12" sm="2" md="2">
                    <v-switch color="#0F2027" v-model="sort_date_wise" label="Sort Date Wise"></v-switch>
                </v-col>
                <v-btn @click="getReport()" :disabled="fromdate == null || todate == null" :loading="loader"
                    class="button mt-7 pt-0">Proceed</v-btn>
            </v-row>
        </v-card>
        <v-card class="box" v-if="payment_transaction_history_list != ''">
            <div id="my-table-id">
                <v-data-table v-if="payment_transaction_history_list.length > 0" dense :headers="headers"
                    :items="bookList1" :search="search" class="elevation-1 mytable" @current-items="getFiltered">
                    <template v-slot:top class="pb-5">
                        <v-row justify="center" align="center">
                            <tr class="t-row ">
                                <div>
                                    <th>
                                        <v-col cols="12" sm="12" md="12">
                                            <v-row>
                                                <!-- <download-excel class="mr-2 pb-3 pt-2" :data="bookList1" :fields="table_fields" worksheet="Payment_transaction_history" name="Payment_transaction_history.xls">
                                              <v-btn color="success" outlined rounded> <v-icon dark>mdi-file-excel</v-icon> Export </v-btn>
                                          </download-excel> -->
                                                <v-col cols="6" sm="2" md="2">
                                                    <v-btn class="mr-2 pb-3 pt-2 " rounded color="success" outlined
                                                        v-if="payment_transaction_history_list.length != 0"
                                                        @click="fnExcelReport('my-table-id', 'PaymentTransactionHistoryReport')"
                                                        :loading="loader"><v-icon
                                                            color="success">mdi-export</v-icon>Export</v-btn>
                                                </v-col>
                                                <span v-for="header in headers" :key="header.text">
                                                    <span v-if="filters.hasOwnProperty(header.value)">
                                                        <v-autocomplete class="mr-2 pb-5 pt-2 no-display" flat
                                                            hide-details small rounded dense outlined color="#0F2027"
                                                            :label="header.text" multiple clearable
                                                            :items="columnValueList(header.value)"
                                                            v-model="filters[header.value]"></v-autocomplete>
                                                    </span>
                                                </span>
                                            </v-row>
                                        </v-col>
                                    </th>
                                </div>
                            </tr>
                        </v-row>
                    </template>
                    <template v-slot:item.actions="{ item }">
                        <v-btn link @click="toggleItem(item)" v-if="item.raise_issue == 'Yes'" :loading="status_loader">
                            <!-- <v-icon class="mr-2"> mdi-refresh </v-icon> -->
                            <v-switch></v-switch>
                        </v-btn>
                    </template>
                </v-data-table>
            </div>
        </v-card>
    </div>
</template>
<script>
  import axios from "axios";
import "@/assets/css/color.css"; // css needs to be imported for each dashboard
import Breadcrumbs from "@/components/shared/Breadcrumbs.vue"; // Adjust the path as needed
export default {
    components: {
        Breadcrumbs,
    },
      data: () => ({
          snackbar_msg: "",
          color: "",
          snackbar: false,
        //   extraBreadcrumbItems: [


        //   ],
        //   breadcrumbClass: "breadcrumb-style1",
          academic_year_list: null,
          current_academic_year: null,
          payment_transaction_history_list: [],
          loader: false,
          status_loader: false,
          filterArr: [],
          fromdate: null,
          todate: null,
          sort_date_wise: false,
          filters: {
              trxn_id: [],
              order_id: [],
              initiatedby: [],
              date: [],
              paymenttransactionstatus: [],
              raise_issue: [],
              issue_resolved_staus: [],
              standard: [],
              division: [],
              stream: [],
          },
          table_fields: {
              "Sr. No": "srno",
              "Initiated By": "initiatedby",
              Student: "learner",
              Standard: "standard",
              Division: "division",
              Stream: "stream",
              "Order Id": "order_id",
              "Transaction Id": "trxn_id",
              "Payment Status": "paymenttransactionstatus",
              Date: "date",
              Amount: "amount",
              Purpose: "purpose",
          },
          headers: [
              { text: "Sr. No.", value: "srno", sortable: false },
              { text: "Initiated By", value: "initiatedby", sortable: false },
              { text: "Student", value: "learner", sortable: false },
              { text: "Standard", value: "standard", sortable: false },
              { text: "Division", value: "division", sortable: false },
              { text: "Stream", value: "stream", sortable: false },
              { text: "Order Id", value: "order_id", sortable: false },
              { text: "AY", value: "ay", sortable: false },
              { text: "Transaction Id", value: "trxn_id", sortable: false },
              {
                  text: "Payment Status",
                  value: "paymenttransactionstatus",
                  sortable: false,
              },
              { text: "Amount", value: "amount", sortable: false },
              { text: "Initaited Date", value: "intiated_on", sortable: false },
              { text: "Transaction Date", value: "date", sortable: false },
              { text: "Purpose", value: "purpose", sortable: false },
              { text: "PG response msg", value: "response_msg", sortable: false },
              { text: "Issue Raised", value: "raise_issue", sortable: false },
              {
                  text: "Issue Resolved",
                  value: "issue_resolved_staus",
                  sortable: false,
              },
              { text: "Toggle Resolved status", value: "actions", sortable: false },
              { text: "Merchant-ID", value: "merchantid", sortable: false },
          ],
      }),
      computed: {
          bookList1() {
              return this.payment_transaction_history_list.filter((d) => {
                  return Object.keys(this.filters).every((f) => {
                      return this.filters[f].length < 1 || this.filters[f].includes(d[f]);
                  });
              });
          },
      },
      methods: {
        fnExcelReport(id, name) {
  let tab_text = `<table border='1px'>
    <tr>
      <th>SR. No.</th>
      <th>Initiated By</th>
      <th>Student</th>
      <th>Order Id</th>
      <th>AY</th>
      <th>Transaction Id</th>
      <th>Payment Status</th>
      <th>Amount</th>
      <th>Initiated Date</th>
      <th>Transaction Date</th>
      <th>Purpose</th>
      <th>PG Response Msg</th>
      <th>Issue Raised</th>
      <th>Issue Resolved</th>
      <th>Toggle Resolved Status</th>
      <th>Merchant-ID</th>
    </tr>`;

  this.payment_transaction_history_list.forEach((s, index) => {
    tab_text += `
    <tr>
        <td>${index + 1}</td>
        <td>${s.initiatedby}</td>
        <td>${s.learner}</td>
        <td>${s.order_id}</td>
        <td>${s.ay}</td>
        <td>${s.trxn_id}</td>
        <td>${s.paymenttransactionstatus}</td>
        <td>${s.amount}</td>
        <td>${s.intiated_on}</td>
        <td>${s.date}</td>
        <td>${s.purpose}</td>
        <td>${s.response_msg}</td>
        <td>${s.raise_issue}</td>
        <td>${s.issue_resolved_staus}</td>
        <td><v-switch></v-switch></td>
        <td>${s.merchantid}</td>
      </tr>`;
  });

  tab_text += '</table>';

  const blob = new Blob([tab_text], {
    type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
  });
  const filename = name + '_' + parseInt(Math.random() * 10000000000) + '.xls';

  if (window.navigator && window.navigator.msSaveOrOpenBlob) {
    // For IE
    window.navigator.msSaveOrOpenBlob(blob, filename);
  } else {
    // For modern browsers
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = filename;
    a.click();
    window.URL.revokeObjectURL(url);
  }
},
          toggleItem(item) {
              console.log("item", item);
              const formData = {
                  ptid: item.id,
              };
              this.status_loader = true;
              axios
                  .post("/AccountingAndFeesReports/toggleDisputeStatus", formData)
                  .then((res) => {
                      //this.payment_transaction_history_list = res.data.payment_transaction_history_list;
                      if (res.data.flag == "YES") {
                          this.showSnackbar("green", res.data.snackbar);
                          item.issue_resolved_staus = res.data.issue_resolved_staus;
                      } else {
                          this.showSnackbar("red", res.data.snackbar);
                          sessionStorage.setItem("error-trace", res.data.error_trace);
                      }
                      this.status_loader = false;
                  })
                  .catch((error) => {
                      window.console.log(error);
                      this.showSnackbar("red", "Something went wrong!!!");
                      this.status_loader = false;
                  })
                  .finally(() => {
                      //close loader
                      this.status_loader = false;
                  });
          },
          getFiltered(e) {
              this.filterArr = e;
          },
          columnValueList(val) {
              return this.payment_transaction_history_list.map((d) => d[val]);
          },
          getReport() {
              if (this.fromdate == null) {
                  alert("Please select From Date!!!");
                  return;
              }
              if (this.todate == null) {
                  alert("Please select To Date!!!");
                  return;
              }
              const formData = {
                  fromdate: this.fromdate,
                  todate: this.todate,
                  sort_date_wise: this.sort_date_wise,
              };
              this.loader = true;
              axios
                  .post("/AccountingAndFeesReports/getPaymentTransactionHistory", formData)
                  .then((res) => {
                      this.payment_transaction_history_list = res.data.payment_transaction_history_list;
                      if(this.payment_transaction_history_list == '' || this.payment_transaction_history_list == [] || this.payment_transaction_history_list ==null){
                        this.showSnackbar("red", "No Trasactions Found");
                      }
                      this.loader = false;
                  })
                  .catch((error) => {
                      window.console.log(error);
                      this.loader = false;
                  })
                  .finally(() => {
                      //close loader
                      this.loader = false;
                  });
          },
          showSnackbar(clr, msg) {
              this.snackbar = true;
              this.color = clr;
              this.snackbar_msg = msg;
          },
      },
      mounted() {},
  };
</script>
<style scoped>
  input[type="date"] {
      width: 30%;
      display: inline-block;
      padding: 0.3rem;
      border: 1px solid gray;
      border-radius: 30px;
      box-sizing: border-box;
      padding-top: none !important;
      margin-top: none !important;
  }
  /* .mytable thead th {
color: red;
} */
</style>

